<template>
	<v-tabs centered show-arrows slider-color="secondary">
		<v-tab
			:key="path"
			:to="isAdminMode ? `/admin/${path}` : `${path}`"
			nav
			v-for="{ path, meta: { title, icon } } in routes"
		>
			<!-- <v-icon left>{{ icon }}</v-icon> -->
			{{ title }}
		</v-tab>
	</v-tabs>
</template>

<script>
export default {
	name: 'AppNavTabs',
	props: {
		isAdminMode: Boolean,
		routes: Array
	}
}
</script>